// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2le0y","title":"FrontImage_title__9tgSQ"};